import { delay, of, OperatorFunction, switchMap } from 'rxjs';

/**
 * Emits `true` values immediately and `false` values with a delay.
 * To be used on `loading$` Observables to show the loading spinner for at least X amount of time for nicer UX.
 */
export function showLoaderFor(timeMs: number): OperatorFunction<boolean, boolean> {
  return switchMap((loading) => {
    if (!loading) {
      return of(false).pipe(delay(timeMs));
    }

    return of(true);
  });
}
